import { get } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { compose, lifecycle, withState } from "recompose"
import qs from "qs"
import { Container, Message } from "semantic-ui-react"
import uniqid from "uniqid"
import { signIn } from "./../../redux/modules/authentication"

const OAuth = ({ isError }) =>
	isError ? (
		<Container>
			<Message header="Wystąpił błąd logowania" icon="warning sign" negative />
		</Container>
	) : null

OAuth.propTypes = {
	isError: PropTypes.bool
}

const mapStateToProps = ({ authentication: { accessToken }, configuration }) => ({
	isAuthenticated: accessToken !== null,
	configuration
})

const mapDispatchToProps = dispatch => ({
	signIn: (accessToken, tokenType) => dispatch(signIn({ accessToken, tokenType }))
})

const enhance = compose(
	withRouter,
	connect(
		mapStateToProps,
		mapDispatchToProps
	),
	withState("isError", "setError", false),
	lifecycle({
		async componentDidMount() {
			const { configuration, history, isAuthenticated, signIn, setError } = this.props
			if (isAuthenticated) {
				history.push("/")
			} else if (history.location.hash.length > 0) {
				const { access_token: accessToken, state, token_type: tokenType } = qs.parse(
					history.location.hash.slice(1)
				)
				const stateFromSession = window.sessionStorage.getItem("oauthState")
				if (state === stateFromSession) {
					await signIn(accessToken, tokenType)
					history.push("/")
				} else {
					setError(true)
				}
			} else {
				const host = get(configuration, "oAuthHost", "https://oauth.madkom.pl")
				const clientId = get(configuration, "oAuthClientId", window.location.host)
				const redirectUri = window.location.href
				const state = uniqid()
				window.sessionStorage.setItem("oauthState", state)
				window.location =
					`${host}/server/authorize?` +
					`response_type=token&` +
					`client_id=${clientId}&` +
					`redirect_uri=${redirectUri}&` +
					`state=${state}`
			}
		}
	})
)

export default enhance(OAuth)



// WEBPACK FOOTER //
// ./src/containers/oauth/OAuth.js